import fontColorContrast from 'font-color-contrast'
import React, { useContext, useEffect, useState } from 'react'
import { Alert, Col, Modal, Row, Spinner } from 'react-bootstrap'
import VerificationInput from 'react-verification-input'
import axios from 'axios'
import CartCtx from '../../../CartCtx'

const ConfirmEmailForm = ({ data, handleResend, confirmResendData, onConfirm }) => {

    const {
        button_color,
        text_1,
        text_2,
        text_3,
        text_4,
        text_5,
        text_6,
        text_7,
        text_8,
        text_9,
        text_10 = 'Карта успешно добавлена',
        text_14 = 'Введите код высланный на почту'
    } = data?.setting

    const { setIsShowAuthModal } = useContext(CartCtx)

    const [isShowModalAuthLink, setIsShowModalAuthLink] = useState(false)

    const [isAlertSuccess, setIsAlertSuccess] = useState(false);
    const [isAlertError, setIsAlertError] = useState(false);
    const [textOnError, setTextOnError] = useState('');

    const [isLoading, setIsLoading] = useState(false); // загрузка при отправке
    const [confirmCode, setConfirmCode] = useState('')

    const TIME = 120
    const [timer, setTimer] = useState(TIME)

    let interval
    useEffect(() => {
        interval = setInterval(() => {
            setTimer(prev => prev > 0 ? --prev : 0)
        }, 1000);
        return () => {
            clearInterval(interval)
        }
    }, [])


    useEffect(() => {
        if (!timer && interval) {
            clearInterval(interval)
        }
    }, [timer, interval])

    const toFormatTimer = (time) => {
        let m = Math.trunc(time / 60);
        let s = time - (m * 60);
        return m + ':' + (s < 10 ? ('0' + s) : s)
    };

    const resendCode = () => {
        setConfirmCode('')
        setTimer(TIME)
        handleResend()
    }

    const handleConfirmCode = () => {
        // const info = await fetchClientInfo()
        setIsLoading(true)
        const sendData = { ...confirmResendData, ...{ email_code: confirmCode } }
        axios
            .post(`${process.env.REACT_APP_API_BASE}/registration/new-card-final`, sendData)
            .then((response) => {
                if (response?.data && response.data?.res) {
                    if (response.data.res === 'Success') {
                        setIsAlertSuccess(true)
                        setIsAlertError(false)
                    }
                    if (response.data.res === 'Error') {
                        setIsAlertError(true)
                        const errText = data?.setting?.[response.data?.msgKey] || 'Что-то пошло не так, попробуйте повторить позже'
                        setTextOnError(errText)
                    }
                    if (response.data.token && onConfirm) {
                        onConfirm(response.data.token)
                    }
                    else {
                        setIsShowModalAuthLink(true)
                    }
                }
                // reset()
            })
            .catch((err) => {
                console.log(err)
                setIsAlertError(true)
                setTextOnError('Что-то пошло не так')
            })
            .finally(() => {
                setIsLoading(false)
            });
    }


    return (
        <>

            <Modal
                show={isShowModalAuthLink}
                onHide={() => {
                    setIsShowModalAuthLink(false)
                }}
                aria-labelledby="contained-modal-title-vcenter"
                centered
                dialogClassName="modal-checkout__complete"
            >
                <Modal.Header closeButton>
                    <Modal.Title>Авторизируйтесь</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {/* {
                        isAlertSuccess &&
                        <div className='h5 mb-3 mt-3' dangerouslySetInnerHTML={{ __html: text_10 }} />
                    } */}
                    <div className="text">
                        <h5 onClick={() => {
                            setIsShowModalAuthLink(false)
                            setIsShowAuthModal(true)
                        }}>
                            Авторизоваться
                        </h5>
                    </div>
                </Modal.Body>
            </Modal>
            <Row className='justify-content-center'>
                <Col md={8} lg={8} xl={6} className='mb-2' >

                    <div className='light buildedPage-type_8-form d-flex flex-column align-items-center' style={{ gap: 16 }}>

                        {
                            isAlertError &&
                            <Alert
                                style={{ width: '100%' }}
                                variant={'danger'}
                                onClose={() => {
                                    setIsAlertError(false)
                                    setTextOnError('')
                                }}
                                dismissible
                            >
                                <Alert.Heading style={{ fontSize: '1.15rem' }}>Ошибка</Alert.Heading>
                                <p className='mb-0'>{textOnError}</p>
                            </Alert>
                        }
                        {
                            isAlertSuccess ?
                                <div className='h5 mb-3 mt-3' dangerouslySetInnerHTML={{ __html: text_10 }} />
                                :
                                <>

                                    <div className='h5 mb-3' dangerouslySetInnerHTML={{ __html: text_14 }} />
                                    <VerificationInput
                                        value={confirmCode}
                                        onChange={(e) => {
                                            setConfirmCode(e)
                                        }}
                                        length={4}
                                        autoFocus={true}
                                        placeholder={'0'}
                                        classNames={{
                                            character: 'character',
                                            characterInactive: "character--inactive",
                                            characterSelected: "character--selected",
                                            characterFilled: "character--filled",
                                        }}

                                    />
                                    <div>
                                        {
                                            timer ?
                                                <div className='text-muted'>{text_3} через {toFormatTimer(timer)} </div>
                                                :
                                                <div className='text-primary' onClick={resendCode} style={{ cursor: 'pointer' }}>{text_3}</div>
                                        }
                                    </div>
                                    <button
                                        disabled={confirmCode.length !== 4}
                                        className='btn btn-submit'
                                        type='submit'
                                        style={{
                                            backgroundColor: button_color,
                                            color: fontColorContrast(button_color)
                                        }}
                                        onClick={handleConfirmCode}
                                    >
                                        {
                                            isLoading ?
                                                <Spinner animation='border' />
                                                :
                                                <div dangerouslySetInnerHTML={{ __html: text_4 || "Отправить" }}></div>
                                        }
                                    </button>

                                </>
                        }
                    </div>
                </Col>
            </Row>
        </>
    )
}

export default ConfirmEmailForm